<template>
    <div id="footContainer">
        <div id="foot-wrapper">
            <ul class="foot-link">
                <li class="link-title">友情链接</li>
                <li @click="toUrl('http://www.caupd.com/index.asp')">中国城市规划设计研究院</li>
                <li @click="toUrl('http://www.chinacitywater.org/')">中国城镇供水排水协会</li>
                <li @click="toUrl('http://www.hit.edu.cn/')">哈尔滨工业大学</li>
                <li @click="toUrl('http://www.tjwatergroup.com/pages/qt/index.html')">天津水务集团有限公司</li>
                <li @click="toUrl('http://www.czws.com/')">沧州供水排水集团有限公司</li>
            </ul>
            <ul class="foot-link">
                <li class="link-title">走进三博</li>
                <router-link to="/introduction" tag="li">公司简介</router-link>
                <router-link to="/service" tag="li">解决方案</router-link>
                <router-link to="/news" tag="li">新闻中心</router-link>
                <router-link to="/product?id=0" tag="li">产品展示</router-link>
                <router-link to="/case" tag="li">客户案例</router-link>
            </ul>
            <ul class="foot-link">
                <li class="link-title">产品展示</li>
                <router-link to="/product?id=1" tag="li">水力模型</router-link>
                <router-link to="/product?id=2" tag="li">产销差计算</router-link>
                <router-link to="/product?id=5" tag="li">二次供水</router-link>
                <router-link to="/product?id=6" tag="li">巡检系统</router-link>
                <router-link to="/product?id=7" tag="li">抄表系统</router-link>
            </ul>
            <ul class="foot-link">
                <li class="link-title">新闻中心</li>
                <router-link to="/news" tag="li">公司新闻</router-link>
                <router-link to="/news" tag="li">行业动态</router-link>
            </ul>
            <ul class="foot-link">
                <li class="link-title">联系我们</li>
                <router-link to="/contact" tag="li">服务与支持</router-link>
                <li><img src="../../assets/imgs/code.jpg"></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name:'Foot',
    methods:{
        toUrl(url){ //路由跳转
            window.location.href = url; 
        }
    }
}
</script>

<style scoped>
    #footContainer{
        background: #2e3139;
        color: #fff;
        width: 100%;
        height: 262px;
        padding-top:65px;
        padding-bottom: 48px;
    }
    #foot-wrapper{
        width: 1120px;
        margin: 0 auto;
        overflow: hidden;
    }
    .foot-link{
        float: left;
        text-align: center;
    }
    .foot-link>li{
        font-size: 17.24px;
        margin-bottom: 20px;
        cursor: pointer;
    }
    .link-title{
        font-size: 20.68px !important;
        font-weight: bold;
    }
    .foot-link:nth-child(1){
        width: 277px;
    }
    .foot-link:nth-child(2){
        width: 242px;
    }
    .foot-link:nth-child(3){
        width: 200px;
    }
    .foot-link:nth-child(4){
        width: 190px;
    }
    .foot-link:nth-child(5){
        width: 211px;
    }
    .foot-link:nth-child(5)>li>img{
        width: 125px;
    }
</style>
